import React from 'react';

import PropTypes from '../../propTypes';
import { TranslatedMessage } from 'common/components/Intl';
import AddressFields from '../forms/AddressFields';
import { ALTERNATE } from 'apps/age_verification/constants';

const SimpleFormAddressFormGroup = ({
  showAddressFields,
  titleMessageId,
  descriptionMessageId,
  addressFieldsMeta,
  onAddressSelect,
  selectedState,
  layout,
  country,
  renderNameFields,
}) => (
  <div className="AddressFieldGroup">
    <div className="AddressForm__group">
      {showAddressFields && titleMessageId && descriptionMessageId && (
        <>
          <div className="AddressForm__group-title">
            <TranslatedMessage id={titleMessageId} />
          </div>
          <p className="AddressForm__group-description">
            <TranslatedMessage id={descriptionMessageId} />
          </p>
        </>
      )}

      {layout === ALTERNATE && renderNameFields()}

      {showAddressFields && (
        <AddressFields
          country={country}
          fieldsMeta={addressFieldsMeta}
          onAddressSelect={onAddressSelect}
          selectedState={selectedState}
          showSingleColumn={true}
        />
      )}
    </div>
  </div>
);

SimpleFormAddressFormGroup.propTypes = {
  showAddressFields: PropTypes.bool,
  titleMessageId: PropTypes.string,
  descriptionMessageId: PropTypes.string,
  addressFieldsMeta: PropTypes.array,
  onAddressSelect: PropTypes.func,
  selectedState: PropTypes.object,
  layout: PropTypes.string,
  country: PropTypes.string,
  renderNameFields: PropTypes.func,
};

SimpleFormAddressFormGroup.defaultProps = {
  showAddressFields: false,
};

export default SimpleFormAddressFormGroup;
